import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { ClickAwayListener } from '@material-ui/core';

import Icon from 'src/components/Icon/Icon';
import HorseMarket from './Components/HorseMarket';
import './TypeCodes.scss';
import CardCodes from './Components/CardCodes';
import NumberCodes from './Components/NumberCodes';
import SportMarket from './Components/SportMarket';

interface TypeCodesProps {
  closeModal: () => void,
  changeFocus?: Function,
  children: React.ReactNode
  title?: string
}

export default function TypeCodes({ closeModal, children, title, changeFocus }: TypeCodesProps) {
  const modalRef = useRef(null);
  let offsetTop = 100;

  const escapeModal = (e) => {
    if (e.key === 'I' && e.shiftKey){
      changeFocus();
    }

    if (e.key === 'Shift'){
      e.preventDefault();
      closeModal();
    } else if (e.key === 'ArrowDown'){
      e.preventDefault();
      modalRef.current.scrollTo(0, offsetTop);
      offsetTop += 100;
    } else if (e.key === 'ArrowUp'){
      e.preventDefault();
      offsetTop -= 100;
      modalRef.current.scrollTo(0, offsetTop);
    }
  };

  useEffect(() => {
    addEventListener('keydown', escapeModal);
    return () => {
      removeEventListener('keydown', escapeModal);
    };
  }, []);

  useLayoutEffect(() => {
    if (modalRef.current){
      modalRef.current.focus();
    }
  }, [modalRef]);

  return (
    <ClickAwayListener onClickAway={ closeModal }>
      <div className="type-codes">
        <div className="type-codes__title">
          { title }
          <Icon icon="close" className="type-codes__close" onClick={ closeModal } />
        </div>
        <div className="type-codes__content" ref={ modalRef }>
          <table className="type-codes__table">
            { children }
          </table>
        </div>
      </div>
    </ClickAwayListener>
  );
}

TypeCodes.HorseMarket = HorseMarket;
TypeCodes.CardCodes = CardCodes;
TypeCodes.NumberCodes = NumberCodes;
TypeCodes.SportMarket = SportMarket;

